export class Playroom {
  [x: string]: any;
  id: number;
  roomName: string;
  phone: string;
  workingHoursTo: string;
  workingHoursFrom: string;
  managerId: null;
  address: string;
  users: [];

  constructor() {
    this.id = null;
    this.roomName = '';
    this.phone = '';
    this.workingHoursTo = '';
    this.workingHoursFrom = '';
    this.users = null;
    this.address = '';
  }
}
